import { render, staticRenderFns } from "./ValueText.vue?vue&type=template&id=96699c4e&"
import script from "./ValueText.vue?vue&type=script&lang=js&"
export * from "./ValueText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports